module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA10lEQVQ4jaWSUZLEIAhEn1tzL7mZeLP2ZOyHyWiiqZmt7S8paOhG4J9IAO4e3xSXUtKbmNJIuHsMEFf0WFIcdUSMeT83MUA8xFBKodZ6Ufsaz0FsTZgcqADIDDO7KD4nLAo6WUQpZzkmIYmIQNJlL1ODruAkt9bAC+CAL8RNg7RmPR38wH3LXxV0G21MfCCemJaYgMABswxkcD9s1McG6w7MBsH9eDuSfacg54wEZmMnksjZmG1uGow7yHm+ttTtbMg3C58ucfNLs4LWBLQp9Snej/kLEsAvTb2G96VarLwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/HTML.png
// module id = 63
// module chunks = 0